document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initMarquee();
  initGalería();
  initVariantes();
  initComparador();
  initFaq();
  initBundle();
  initBundleCards();
  initStickyAtc();
  initProductFormAjax();
  initHeroCarousel();
});

function mtToast(message, opts) {
  opts = opts || {};
  var el = document.querySelector('.mt-toast');
  if (!el) {
    el = document.createElement('div');
    el.className = 'mt-toast';
    document.body.appendChild(el);
  }
  el.innerHTML = '<span class="mt-toast-msg"></span>';
  el.querySelector('.mt-toast-msg').textContent = message;
  if (opts.link) {
    var a = document.createElement('a');
    a.href = opts.link;
    a.className = 'mt-toast-link';
    a.textContent = opts.linkText || 'View';
    el.appendChild(a);
  }
  el.classList.toggle('mt-toast-error', !!opts.error);
  el.classList.add('mt-toast-visible');
  clearTimeout(el._mtToastTimer);
  el._mtToastTimer = setTimeout(function () {
    el.classList.remove('mt-toast-visible');
  }, opts.error ? 4500 : 3200);
}

function mtUpdateCartBubble(count) {
  var bubbleWrap = document.querySelector('#cart-icon-bubble');
  if (!bubbleWrap) return;
  var bubble = bubbleWrap.querySelector('.cart-count-bubble');
  if (count > 0) {
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubbleWrap.appendChild(bubble);
    }
    bubble.innerHTML = '<span aria-hidden="true">' + (count < 100 ? count : '') + '</span>';
  } else if (bubble) {
    bubble.remove();
  }
}

function initProductFormAjax() {
  document.querySelectorAll('[data-mt-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var addBtn = form.querySelector('[data-mt-add-btn]');
      var originalLabel = addBtn ? addBtn.textContent : null;
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Adding…'; }

      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fd
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) {
            var msg = (result.data && result.data.description) || 'Something went wrong — please try again.';
            mtToast(msg, { error: true });
            if (addBtn) { addBtn.disabled = false; addBtn.textContent = originalLabel; }
            return;
          }
          mtToast('Added to cart', { link: '/cart', linkText: 'View cart' });
          if (addBtn) { addBtn.textContent = 'Added ✓'; }
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              mtUpdateCartBubble(cart.item_count);
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            })
            .finally(function () {
              setTimeout(function () {
                if (addBtn) { addBtn.disabled = false; addBtn.textContent = originalLabel; }
              }, 1800);
            });
        })
        .catch(function () {
          mtToast('Something went wrong — please try again.', { error: true });
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = originalLabel; }
        });
    });
  });
}

function initStickyAtc() {
  document.querySelectorAll('[data-mt-sticky-atc]').forEach(function (bar) {
    var section = bar.closest('.mt-producto');
    if (!section) return;
    var trigger = section.querySelector('.mt-prod-price-row');
    var mainBtn = section.querySelector('[data-mt-add-btn]');
    var mainPrice = section.querySelector('[data-mt-price]');
    var stickyPrice = bar.querySelector('[data-mt-sticky-price]');
    var stickyBtn = bar.querySelector('[data-mt-sticky-add]');

    if (trigger && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('mt-sticky-atc-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(trigger);
    }

    if (stickyBtn && mainBtn) {
      stickyBtn.addEventListener('click', function () { mainBtn.click(); });
      var syncDisabled = function () {
        stickyBtn.disabled = mainBtn.disabled;
        stickyBtn.textContent = mainBtn.textContent;
      };
      syncDisabled();
      if ('MutationObserver' in window) {
        new MutationObserver(syncDisabled).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
      }
    }

    if (mainPrice && stickyPrice && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { stickyPrice.textContent = mainPrice.textContent; });
      mo.observe(mainPrice, { childList: true, characterData: true, subtree: true });
    }
  });
}

function initBundleCards() {
  document.querySelectorAll('[data-mt-bundle-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (window.Shopify && document.querySelector('cart-notification')) {
            fetch('/cart?section_id=cart-notification-product').catch(function () {});
          }
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = originalText;
          }, 1800);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  });
}

function initBundle() {
  document.querySelectorAll('[data-mt-bundle-variants]').forEach(function (bundle) {
    var opts = bundle.querySelectorAll('[data-mt-bundle-variant-opt]');
    var form = bundle.closest('[data-mt-product-form]');
    var variantInput = form ? form.querySelector('[data-mt-variant-input]') : null;
    var addBtn = form ? form.querySelector('[data-mt-add-btn]') : null;
    var priceEl = document.querySelector('[data-mt-price]');
    var compareEl = document.querySelector('[data-mt-compare-price]');
    var defaultLabel = addBtn ? addBtn.getAttribute('data-mt-label-available') : null;
    var soldOutLabel = addBtn ? addBtn.getAttribute('data-mt-label-sold-out') : null;

    function select(opt) {
      opts.forEach(function (o) { o.classList.remove('mt-bundle-active'); });
      opt.classList.add('mt-bundle-active');
      if (variantInput) variantInput.value = opt.getAttribute('data-variant-id') || '';
      if (priceEl) priceEl.textContent = opt.getAttribute('data-price') || '';
      if (compareEl) {
        var compare = opt.getAttribute('data-compare');
        if (compare) { compareEl.textContent = compare; compareEl.style.display = ''; }
        else { compareEl.style.display = 'none'; }
      }
      var available = opt.getAttribute('data-available') === 'true';
      if (addBtn) {
        if (available) {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = opt.getAttribute('data-label-add') || defaultLabel;
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = soldOutLabel;
        }
      }
    }

    opts.forEach(function (opt) {
      opt.addEventListener('click', function () { select(opt); });
    });

    var initial = bundle.querySelector('.mt-bundle-active') || opts[0];
    if (initial) select(initial);
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) { io.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('[data-mt-countup]');
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      io.unobserve(entry.target);
      var el = entry.target;
      var end = parseFloat(el.getAttribute('data-mt-countup')) || 0;
      var decimals = (el.getAttribute('data-mt-countup').split('.')[1] || '').length;
      var suffix = el.getAttribute('data-mt-suffix') || '';
      var dur = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (end * eased).toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { io.observe(el); });
}

function initMarquee() {
  document.querySelectorAll('[data-mt-marquee]').forEach(function (track) {
    if (track.dataset.mtCloned) return;
    track.dataset.mtCloned = '1';
    var clone = track.innerHTML;
    track.insertAdjacentHTML('beforeend', clone);
  });
}

function initGalería() {
  document.querySelectorAll('[data-mt-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-mt-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-mt-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-mt-gallery-thumb');
        if (!full) return;
        main.style.opacity = '0';
        setTimeout(function () {
          main.setAttribute('src', full);
          main.style.opacity = '1';
        }, 160);
        thumbs.forEach(function (t) { t.classList.remove('mt-thumb-active'); });
        thumb.classList.add('mt-thumb-active');
      });
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-mt-product-form]').forEach(function (form) {
    var variantsData = form.querySelector('[data-mt-variants-json]');
    if (!variantsData) return;
    var variants;
    try { variants = JSON.parse(variantsData.textContent); } catch (e) { return; }
    var optionInputs = form.querySelectorAll('[data-mt-option]');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-mt-price]');
    var compareEl = form.querySelector('[data-mt-compare-price]');
    var addBtn = form.querySelector('[data-mt-add-btn]');
    if (!optionInputs.length) return;

    function currentSelection() {
      var sel = [];
      optionInputs.forEach(function (group) {
        var checked = group.querySelector('input:checked, option:checked');
        sel.push(checked ? checked.value : null);
      });
      return sel;
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateFromSelection() {
      var sel = currentSelection();
      var match = variants.find(function (v) {
        return v.options.every(function (val, i) { return val === sel[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (match.available) {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = addBtn.getAttribute('data-mt-label-available') || addBtn.textContent;
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = addBtn.getAttribute('data-mt-label-sold-out') || 'Sold out';
        }
      }
    }

    optionInputs.forEach(function (group) {
      group.addEventListener('change', updateFromSelection);
    });
    updateFromSelection();
  });
}

function initComparador() {
  document.querySelectorAll('[data-mt-comparador]').forEach(function (comp) {
    var handle = comp.querySelector('[data-mt-comparador-handle]');
    var clipped = comp.querySelector('[data-mt-comparador-clip]');
    if (!handle || !clipped) return;

    // Prevent native browser image-drag / text-selection from hijacking the gesture.
    comp.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('draggable', 'false');
      img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    var dragging = false;

    function setPos(clientX) {
      var rect = comp.getBoundingClientRect();
      var pct = Math.min(Math.max((clientX - rect.left) / rect.width, 0), 1) * 100;
      // "Before" is the top layer; clip away everything past the handle
      // position (100-pct% from its right edge) so its visible edge always
      // sits exactly at the handle, revealing the "after" base layer beyond it.
      clipped.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }

    function onMove(e) {
      if (!dragging) return;
      e.preventDefault();
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPos(clientX);
    }

    function onUp() {
      dragging = false;
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
    }

    function onDown(e) {
      e.preventDefault();
      dragging = true;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPos(clientX);
      document.addEventListener('pointermove', onMove, { passive: false });
      document.addEventListener('pointerup', onUp);
    }

    handle.addEventListener('pointerdown', onDown);
    handle.addEventListener('dragstart', function (e) { e.preventDefault(); });

    comp.addEventListener('click', function (e) {
      if (e.target === handle || handle.contains(e.target)) return;
      setPos(e.clientX);
    });
  });
}

function initFaq() {
  document.querySelectorAll('[data-mt-faq-item]').forEach(function (item) {
    var q = item.querySelector('[data-mt-faq-q]');
    if (!q) return;
    q.addEventListener('click', function () {
      var isOpen = item.classList.contains('mt-faq-open');
      item.closest('[data-mt-faq]').querySelectorAll('[data-mt-faq-item]').forEach(function (i) {
        i.classList.remove('mt-faq-open');
      });
      if (!isOpen) item.classList.add('mt-faq-open');
    });
  });
}

function initHeroCarousel() {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-mt-hero-carousel]').forEach(function (carousel) {
    var slides = carousel.querySelectorAll('[data-mt-hero-slide]');
    if (slides.length < 2 || reduceMotion) return;
    var dots = carousel.querySelectorAll('[data-mt-hero-dots] .mt-hero-dot');
    var interval = parseInt(carousel.getAttribute('data-interval'), 10) || 4000;
    var current = 0;

    function goTo(index) {
      slides[current].classList.remove('mt-hero-slide-active');
      if (dots[current]) dots[current].classList.remove('mt-hero-dot-active');
      current = index;
      slides[current].classList.add('mt-hero-slide-active');
      if (dots[current]) dots[current].classList.add('mt-hero-dot-active');
    }

    setInterval(function () {
      goTo((current + 1) % slides.length);
    }, interval);
  });
}
